import React, { useState, createContext } from 'react';
import CMSEditElementsContainer from '../generic/editCss/CMSEditElementsContainer';
import CMSNeurosales from './CMSNeurosales';
import NeurosalesSelectTiles from './components/pages/SelectTiles/NeurosalesSelectTiles';
import NeurosalesSettings from './components/pages/SettingsPage/NeurosalesSettings';
export const CMSContext = /*#__PURE__*/createContext();
const CMSContextProvider = props => {
  const [numLoaders, setNumLoaders] = useState(0);
  const increaseLoaders = () => {
    // la set di uno state è asincrona
    // in questo modo siamo sicuri che l'update venga fatto in maniera atomica (consistente)
    // soprattutto quando abbiamo MOLTI loader che partono insieme
    setNumLoaders(prevState => prevState + 1);
  };
  const decreaseLoaders = () => {
    setNumLoaders(prevState => prevState - 1);
  };
  return /*#__PURE__*/React.createElement(CMSContext.Provider, {
    value: {
      history: props.history,
      numLoaders: numLoaders,
      increaseLoaders: increaseLoaders,
      decreaseLoaders: decreaseLoaders
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "cms-app",
    className: "cms-app"
  }, props.firstStart || props.selectTile ? /*#__PURE__*/React.createElement(NeurosalesSelectTiles, props) : null, props.settings ? /*#__PURE__*/React.createElement(NeurosalesSettings, {
    setSettingsPage: props.setSettingsPage,
    renderSettings: props.renderSettings,
    allFonts: props.allFonts
  }) : null, !props.firstStart && !props.selectTile && !props.settings ? /*#__PURE__*/React.createElement(CMSNeurosales, props) : null, /*#__PURE__*/React.createElement(CMSEditElementsContainer, props)));
};
export default CMSContextProvider;